import { createContext, useContext, useEffect, useState } from "react";
import { CONTENT } from "@/i18n/content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ila-lang") === "en" ? "en" : "ro");

  useEffect(() => {
    localStorage.setItem("ila-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = CONTENT[lang];
  return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
